/**
 * The words for GH-877: a saved widget's profile / sign-in option, how a widget's buttons and links
 * open, and what the donor sees when the option is on. One place, so the console's option, its
 * preview and the give box itself say the same thing.
 *
 * Rules `embed-widget-copy.test.ts` enforces:
 *   - every label (`*.label`, `*Label`) is five words or fewer — longer lines are hints or body;
 *   - no faith's vocabulary, no urgency and no scarcity — these lines stand beside a Give button
 *     on somebody else's page (DEC-051 keeps scarcity off every give surface);
 *   - giving is never described as needing an account: signing in is always "optional".
 */
export const EMBED_WIDGET_COPY = {
    /* ------------------------------------------------------- the console's option (builder) */
    option: {
        label: "Profile and sign-in",
        hint: "Shows a profile button at the top, and offers sign-in on the card form to anyone not signed in. Signing in is optional: it puts the gift in the donor's receipts.",
        summary: "sign-in",
        /** Under the preview: the card form cannot open there, so say what it will offer. */
        previewNote: "In the box, the card form also offers sign-in to anyone not signed in.",
    },
    /* ------------------------------------------------------------- the give box (donor side) */
    donor: {
        /** The profile button's accessible name, signed out and signed in. */
        profileSignedOutLabel: "Sign in",
        profileSignedInLabel: "Your profile",
        /** On the card form, for a donor who is not signed in. */
        offerLabel: "Have an account? Sign in",
        offerNote: "Optional. Your gift goes in your receipts.",
        signedInNote: "Signed in. This gift goes in your receipts.",
        signOutLabel: "Sign out",
        /** Signed in from the card form: the form closes so the gift is made under the account. */
        signedInContinue: "Signed in. Press Give to continue.",
        windowBlocked: "Your browser blocked the sign-in window.",
        windowBlockedLink: "Open it here",
        /** The small sign-in window a framed box opens (its own page, on GiveHere). */
        windowHeading: "Sign in",
        windowLede: "Optional. Your gift goes in your receipts.",
        windowDone: "You're signed in. You can close this window.",
    },
    /* ----------------------------------------------- how a widget's buttons and links open */
    opens: {
        /** A website button: a small window, falling back to a new tab where scripts are removed. */
        smallWindowLabel: "Small window",
        newTabLabel: "New tab",
        sameTabLabel: "Same tab",
        whenClickedLabel: "When clicked",
        smallWindowHint: "Opens a small payment window over your page. Where a site removes scripts, it opens a new tab instead.",
        newTabHint: "Opens in a new tab.",
        sameTabHint: "Opens in the same tab.",
        /** Emails cannot run scripts, so a small window is not possible there. */
        /** Buttons & links' email answer, for any destination. */
        emailTabNote: "Emails can't run scripts, so this button opens a new tab, not a small window.",
        emailHint: "Emails can't run a give box or open a small window, so this is a Give button. It opens the widget in a new tab, looking just like the preview.",
        printHint: "A QR code for print and a link for documents. Both open this widget, looking just like the preview.",
        widgetButtonTitle: "A button instead",
        widgetButtonHint: "A Give button that opens this widget in a small payment window. No script to install; where a site removes scripts, it opens a new tab.",
    },
    /* ------------------------------------------------------ Buttons & links: "A widget" */
    buttons: {
        placeLabel: "A widget",
        placeHint: "Opens the widget exactly as you built it. Its amounts and starting amount come from the widget.",
        amountFromWidget: "Set by the widget.",
    },
};
//# sourceMappingURL=embed-widget-copy.js.map